<script lang="ts">
export const elCalendarCellColors = [
  'purple',
  'orange',
  'brandBlue',
  'green',
  'rose',
  'indigo',
  'red',
  'pink',
  'cyan',
  'sapphire',
  'teal',
  'yellow',
] as const;
export type ElCalendarCellColor = (typeof elCalendarCellColors)[number];

export const elCalendarCellAvailabilities = ['not-available', 'for-doctors', 'for-patients'] as const;
export type ElCalendarCellAvailability = (typeof elCalendarCellAvailabilities)[number];
</script>

<script setup lang="ts">
import ElTooltip from '@/ElTooltip.vue';

withDefaults(
  defineProps<{
    height?: number;
    color?: ElCalendarCellColor;
    availability?: ElCalendarCellAvailability;
    label?: string;
    showTooltipOnMobile?: boolean;
  }>(),
  {
    height: 48,
    color: undefined,
    availability: 'not-available',
    label: undefined,
    showTooltipOnMobile: false,
  },
);
</script>

<template>
  <div
    class="grid max-w-full"
    :class="{
      'bg-white': availability === 'for-doctors',
      'bg-yellow-100': availability === 'for-patients',
      'bg-neutral-inactive': availability === 'not-available',
      'grid-cols-[8px_1fr]': color != null,
      'grid-cols-[1fr]': color == null,
    }"
  >
    <div
      v-if="color != null"
      class="w-2 h-full"
      :class="{
        'bg-purple-400': color === 'purple',
        'bg-orange-400': color === 'orange',
        'bg-brandBlue-400': color === 'brandBlue' || color === 'sapphire',
        'bg-yellow-400': color === 'yellow',
        'bg-rose-400': color === 'rose',
        'bg-indigo-400': color === 'indigo',
        'bg-red-400': color === 'red',
        'bg-pink-400': color === 'pink',
        'bg-cyan-400': color === 'cyan',
        'bg-teal-400': color === 'teal',
        'bg-green-400': color === 'green',
      }"
    />
    <div class="overflow-hidden">
      <ElTooltip v-if="label" :title="label" :hide-on-mobile="!showTooltipOnMobile">
        <div
          class="flex flex-col justify-center text-sm text-neutral-darker cursor-pointer"
          :class="{
            'px-1': color != null,
            'px-2': color == null,
          }"
          :style="{ height: `${Math.max(12, height)}px` }"
        >
          <span class="truncate">
            {{ label }}
          </span>
        </div>
      </ElTooltip>
      <div
        v-else
        class="flex flex-col justify-center text-sm text-neutral-darker cursor-pointer"
        :class="{
          'px-1': color != null,
          'px-2': color == null,
        }"
        :style="{ height: `${Math.max(12, height)}px` }"
      />
    </div>
  </div>
</template>
